var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { State, Getter } from 'vuex-class';
import { DepartmentService } from '~/services/management-service/department.service';
import { CompanyService } from '~/services/management-service/company.service';
import CommissionSet from '~/components/case-import/client-manage/commission-set.vue';
var AddOrganize = /** @class */ (function (_super) {
    __extends(AddOrganize, _super);
    function AddOrganize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addOrgModel = {
            companyCode: '',
            deptField: '123',
            deptName: '',
            deptType: '',
            description: '',
            parentId: '1',
            deptStatus: 'ENABLED',
            performanceDetail: [],
            principalCode: '',
            principalName: '',
            principalId: ''
        };
        _this.commissionData = [];
        /**
         * 添加机构信息校验规则
         */
        _this.addOrganizeRules = {
            deptName: { required: true, message: '请输入机构名称', trigger: 'blur' },
            deptType: { required: true, message: '请选择组织机构', trigger: 'change' },
            companyName: {
                required: true,
                message: '请选择公司名称',
                trigger: 'change',
            },
        };
        return _this;
    }
    Object.defineProperty(AddOrganize.prototype, "isShow", {
        get: function () {
            var _this = this;
            var list = ["TEL", "VISIT", 'LEGAL'];
            return list.find(function (v) { return v === _this.addOrgModel.deptType; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 关闭窗口
     */
    AddOrganize.prototype.close = function () {
        var form = this.$refs['addOrg'];
        form.resetFields();
        this.$emit('close');
        this.commissionData = [];
    };
    AddOrganize.prototype.refresh = function (adddata) {
        if (!adddata) {
            return;
        }
        this.addOrgModel.parentId = adddata.id;
        this.addOrgModel.companyCode = adddata.companyCode;
        this.addOrgModel.deptType = adddata.deptType;
    };
    AddOrganize.prototype.principalChange = function (val) {
        if (val) {
            var item = this.principalList.content.find(function (v) { return v.id === val; });
            this.addOrgModel.principalName = item.name;
            this.addOrgModel.principalCode = item.principalCode;
        }
        else {
            this.addOrgModel.principalName = '';
            this.addOrgModel.principalCode = '';
        }
    };
    AddOrganize.prototype.mounted = function () { };
    /**
     * 添加机构确认
     */
    AddOrganize.prototype.addOrganizeCommit = function () {
        var _this = this;
        this.addOrgModel.performanceDetail = this.commissionData;
        var form = this.$refs['addOrg'];
        form.validate(function (valid) {
            _this.addOrgModel.performanceDetail.map(function (v) {
                if (Number(v.rate) > 100)
                    return _this.$message.error('绩效比例不能大于100');
            });
            if (valid) {
                _this.departmentService.createDepartment(_this.addOrgModel).subscribe(function (data) {
                    _this.$message.success('添加机构成功');
                    _this.$emit('refresh');
                    _this.close();
                });
            }
        });
    };
    AddOrganize.prototype.onClickAccount = function () {
        this.commissionData.push({
            overduePeriodStart: '',
            overduePeriodEnd: '',
            paymentAccountType: '',
            rate: '',
            id: ''
        });
    };
    AddOrganize.prototype.change = function (val) { };
    __decorate([
        Dependencies(DepartmentService)
    ], AddOrganize.prototype, "departmentService", void 0);
    __decorate([
        Dependencies(CompanyService)
    ], AddOrganize.prototype, "companyService", void 0);
    __decorate([
        State
    ], AddOrganize.prototype, "companyList", void 0);
    __decorate([
        Getter
    ], AddOrganize.prototype, "isSupperAdmin", void 0);
    __decorate([
        State
    ], AddOrganize.prototype, "principalList", void 0);
    AddOrganize = __decorate([
        Component({
            components: {
                CommissionSet: CommissionSet
            },
        })
    ], AddOrganize);
    return AddOrganize;
}(Vue));
export default AddOrganize;
